import React from 'react';
import classNames from 'classnames';

import { HistoryEvent } from '@api/types';
import { TileWithLoading } from '@react/Pages/AccountSettingsPage/YourDataSection/TileWithLoading';
import { HistoryItem } from '@react/Pages/AccountSettingsPage/YourDataSection/AccountHistoryTile/HistoryItem/HistoryItem';

import './AccountHistoryTile.scss';

interface AccountHistoryTileProps {
  href: string;
  events: HistoryEvent[];
}

const AccountHistoryTileBase: React.FC<AccountHistoryTileProps> = ({ events, href }) => {
  const hasEvents = events.length > 0;

  const eventList = events.map(event => <HistoryItem key={event.id} event={event} />);

  return (
    <div className={classNames('your-data-card', { 'your-data-card--muted': !hasEvents })}>
      <div className="your-data-card__title">{t('label.account-history')}</div>
      <div className="your-data-card__body flex-box-column">
        {hasEvents ? (
          <div className="account-history-tile">
            <ul className="flex-one">{eventList}</ul>
          </div>
        ) : (
          <div className="your-data-card__empty-msg">{t('account-history.no-history.message')}</div>
        )}
      </div>
      <a className="your-data-card__action" href={href}>
        <i className="icon-show" />
      </a>
    </div>
  );
};

export const AccountHistoryTile = TileWithLoading(AccountHistoryTileBase);
